module.exports = __webpack_public_path__ + "static/img/china.fdac042.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/industry/china.png
// module id = uv1z
// module chunks = 1